import React from 'react';

import { ReactComponent as ArrowLong } from 'assets/icons/ic_arrow_long.svg';

interface SlideCardProps {
  title: string;
  src: string;
  onClick: () => void;
}

const SlideCard = ({ title, src, onClick }: SlideCardProps) => {
  return (
    <div
      className="relative flex h-[303px] w-full cursor-pointer overflow-hidden rounded-[25px] bg-center"
      onClick={onClick}
      style={{ backgroundImage: `url(${src})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-50" />
      <div className="z-10 flex h-full w-full flex-col justify-between p-5 text-white">
        <h4 className="w-full whitespace-pre-wrap text-wrap break-keep text-b3">{title}</h4>
        <ArrowLong width={34} height={34} />
      </div>
    </div>
  );
};

export default SlideCard;
